import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { WhatsAppIcon } from "./Brand";
import { useQuiz } from "../../hooks/QuizContext";

export const FloatingWhatsApp = () => {
  const [show, setShow] = useState(false);
  const { openQuiz } = useQuiz();

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.button
          type="button"
          initial={{ opacity: 0, y: 30, scale: 0.8 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 30, scale: 0.8 }}
          whileHover={{ scale: 1.06 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => openQuiz("floating")}
          aria-label="Agendar pelo WhatsApp"
          className="fixed bottom-5 right-5 z-50 flex h-14 items-center gap-2 rounded-full bg-[#1E7E45] px-5 text-[#FFFFFF] shadow-[0_18px_40px_-12px_rgba(30,126,69,0.6)]"
          data-testid="floating-whatsapp-btn"
        >
          <span className="absolute inset-0 -z-10 animate-ping rounded-full bg-[#25D366]/30 motion-reduce:animate-none" aria-hidden="true" />
          <WhatsAppIcon className="h-6 w-6" />
          <span className="hidden text-sm font-semibold sm:inline">Agendar</span>
        </motion.button>
      )}
    </AnimatePresence>
  );
};
